import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getBookingDetailById } from "../../Services/HotelSearchApi";

const HotelPrintTicket = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referenceNo = queryParams.get("ReferenceNo");

  const [bookingDetails, setBookingDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (referenceNo) {
      fetchHotelBookingDetails(referenceNo);
    } else {
      console.warn("Missing referenceNo");
    }
  }, [referenceNo]);

  useEffect(() => {
    if (bookingDetails) {
      const timer = setTimeout(() => {
        window.print();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [bookingDetails]);

  const fetchHotelBookingDetails = async (refId) => {
    try {
      setLoading(true);
      setError("");
      let response = await getBookingDetailById(refId);
      if (Array.isArray(response) && response.length > 0) response = response[0];

      // Defensively handle both wrapped and direct responses
      if (response && response.booking) {
        setBookingDetails(response.booking);
      } else if (response && response.Booking) {
        setBookingDetails(response.Booking);
      } else if (response && response.pkid) {
        setBookingDetails(response);
      } else {
        setBookingDetails(null);
        setError("Booking details not found.");
      }
    } catch (err) {
      console.error("Error fetching hotel details:", err);
      setError("Failed to load hotel booking details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const renderPolicyInstructions = () => {
    const rawInstructions = bookingDetails.policy_Instructions || bookingDetails.policyInstructions || bookingDetails.policy_instructions;
    if (!rawInstructions) return null;

    try {
      const instructions = typeof rawInstructions === "string"
        ? JSON.parse(rawInstructions)
        : rawInstructions;

      if (!Array.isArray(instructions) || instructions.length === 0) return null;

      return (
        <div style={{ marginTop: "20px", width: "100%" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <p style={{ background: "#110942", color: "#dacd65", padding: "8px 15px", fontWeight: "bold", margin: "0" }}>
                    Policy & Instructions
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ border: "1px solid #ccc", padding: "15px", fontSize: "13px", lineHeight: "1.6", borderTop: "none" }}>
            {instructions.map((item, idx) => {
              let parsedMsg = item.msg;
              if (typeof item.msg === "string") {
                try {
                  parsedMsg = JSON.parse(item.msg);
                } catch (e) {
                  parsedMsg = item.msg;
                }
              }

              const title = item.type ? item.type.replace(/_/g, " ") : "INFO";

              return (
                <div key={idx} style={{ marginBottom: "15px" }}>
                  <h5 style={{ margin: "0 0 5px 0", color: "#110942", textTransform: "capitalize", fontWeight: "bold" }}>
                    {title}
                  </h5>
                  {typeof parsedMsg === "object" && parsedMsg !== null ? (
                    Object.entries(parsedMsg).map(([key, val]) => (
                      <p key={key} style={{ margin: "3px 0" }}>
                        <strong>{key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}:</strong> {val}
                      </p>
                    ))
                  ) : (
                    <p style={{ margin: "3px 0" }}>{parsedMsg}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      );
    } catch (error) {
      console.error("Error parsing policy instructions:", error);
      return null;
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <p>Loading ticket details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger m-5">
        {error}
      </div>
    );
  }

  if (!bookingDetails) return null;

  return (
    <div style={{ background: "#fff", margin: "0 auto", width: "1000px", padding: "20px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          <tr>
            <td>
              <table style={{ width: "100%", marginBottom: "20px" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "60%" }}>
                      <img src="/assets/images/logo.png" width={200} alt="Logo" />
                    </td>
                    <td style={{ width: "40%", fontSize: "14px", textAlign: "right" }}>
                      <p><strong>{bookingDetails.companynGstDetails?.name || "Berry Journeys"}</strong></p>
                      <p>Email: {bookingDetails.companynGstDetails?.email || "support@berryjourneys.com"}</p>
                      <p>Phone: {bookingDetails.companynGstDetails?.phone || ""}</p>
                      <p>Address: {bookingDetails.companynGstDetails?.address || ""}</p>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style={{ width: "100%", border: "1px solid #333", marginBottom: "20px" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", padding: "10px", borderRight: "1px solid #333" }}>
                      <p><strong>Booking ID:</strong> {bookingDetails.bookingRefId}</p>
                      <p><strong>Confirmation No:</strong> {bookingDetails.confirmationNo}</p>
                      <p><strong>Status:</strong> <span style={{ color: "green", fontWeight: "bold" }}>{bookingDetails.bookingStatus}</span></p>
                      <p><strong>Booking Date:</strong> {formatDateTime(bookingDetails.createdAt)}</p>
                    </td>
                    <td style={{ width: "50%", padding: "10px", textAlign: "center" }}>
                        <h3 style={{ color: "#110942", margin: "0" }}>HOTEL VOUCHER</h3>
                        <p style={{ margin: "5px 0" }}>Check-in ready voucher</p>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style={{ width: "100%", marginBottom: "20px" }}>
                 <tbody>
                    <tr>
                        <td>
                            <p style={{ background: "#110942", color: "#dacd65", padding: "8px 15px", fontWeight: "bold" }}>
                                Hotel & Stay Information
                            </p>
                        </td>
                    </tr>
                 </tbody>
              </table>

              <table style={{ width: "100%", border: "1px solid #ccc", marginBottom: "20px", fontSize: "14px" }}>
                <thead>
                    <tr style={{ background: "#f8f9fa" }}>
                        <th style={{ border: "1px solid #ccc", padding: "8px" }}>Hotel Name</th>
                        <th style={{ border: "1px solid #ccc", padding: "8px" }}>Check-In</th>
                        <th style={{ border: "1px solid #ccc", padding: "8px" }}>Check-Out</th>
                        <th style={{ border: "1px solid #ccc", padding: "8px" }}>Nights/Rooms</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ border: "1px solid #ccc", padding: "8px", verticalAlign: "top" }}>
                            <strong style={{ color: "#110942", fontSize: "16px" }}>{bookingDetails.hotelName}</strong>
                            <p style={{ margin: "5px 0", color: "#666" }}>{bookingDetails.hotelAddress}</p>
                            <p style={{ margin: "0", color: "#666" }}>{bookingDetails.cityName}</p>
                        </td>
                        <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                            <p style={{ margin: "0", fontWeight: "bold" }}>{formatDate(bookingDetails.checkInDate)}</p>
                            <p style={{ margin: "0" }}>{bookingDetails.checkInTime}</p>
                        </td>
                        <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                            <p style={{ margin: "0", fontWeight: "bold" }}>{formatDate(bookingDetails.checkOutDate)}</p>
                            <p style={{ margin: "0" }}>{bookingDetails.checkOutTime}</p>
                        </td>
                        <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                            <p style={{ margin: "0" }}>{bookingDetails.noOfNights} Night(s)</p>
                            <p style={{ margin: "0" }}>{bookingDetails.noOfRooms} Room(s)</p>
                        </td>
                    </tr>
                </tbody>
              </table>

              {bookingDetails.rooms?.map((room, index) => {
                const isRefundable = room.refundable || bookingDetails.rooms?.[0]?.refundable;
                return (
                  <div key={index} style={{ marginBottom: "20px" }}>
                      <p style={{ background: "#f1f1f1", padding: "5px 15px", fontWeight: "bold", border: "1px solid #ccc", borderBottom: "none" }}>
                          Room {index + 1}: {room.roomName} ({isRefundable ? "Refundable" : "Non-Refundable"})
                      </p>
                      <table style={{ width: "100%", border: "1px solid #ccc", borderCollapse: "collapse", fontSize: "13px" }}>
                          <thead>
                              <tr style={{ background: "#f8f9fa" }}>
                                  <th style={{ border: "1px solid #ccc", padding: "5px" }}>Guest Name</th>
                                  <th style={{ border: "1px solid #ccc", padding: "5px" }}>Type</th>
                                  <th style={{ border: "1px solid #ccc", padding: "5px" }}>PAN</th>
                                  <th style={{ border: "1px solid #ccc", padding: "5px" }}>Meal Plan</th>
                              </tr>
                          </thead>
                          <tbody>
                              {room.paxDetails?.map((pax, pIdx) => (
                                  <tr key={pIdx}>
                                      <td style={{ border: "1px solid #ccc", padding: "5px" }}>
                                          {pax.title}. {pax.firstName} {pax.lastName} {pax.isLeadGuest ? "(Lead)" : ""}
                                      </td>
                                      <td style={{ border: "1px solid #ccc", padding: "5px", textAlign: "center" }}>{pax.paxType}</td>
                                      <td style={{ border: "1px solid #ccc", padding: "5px", textAlign: "center" }}>{pax.panNumber || "-"}</td>
                                      <td style={{ border: "1px solid #ccc", padding: "5px", textAlign: "center" }}>{room.mealBasis || "N/A"}</td>
                                  </tr>
                              ))}
                          </tbody>
                      </table>
                  </div>
                );
              })}

              {bookingDetails.gstNumber && (
                <>
                  <table style={{ width: "100%", marginTop: "20px" }}>
                    <tbody>
                        <tr>
                            <td>
                                <p style={{ background: "#110942", color: "#dacd65", padding: "8px 15px", fontWeight: "bold" }}>
                                    GST Details
                                </p>
                            </td>
                        </tr>
                    </tbody>
                  </table>
                  <table style={{ width: "100%", border: "1px solid #ccc", fontSize: "14px", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ background: "#f8f9fa" }}>
                            <th style={{ border: "1px solid #ccc", padding: "8px" }}>GST Name</th>
                            <th style={{ border: "1px solid #ccc", padding: "8px" }}>GST No</th>
                            <th style={{ border: "1px solid #ccc", padding: "8px" }}>GST Email</th>
                            <th style={{ border: "1px solid #ccc", padding: "8px" }}>GST Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>{bookingDetails.gstName || "NA"}</td>
                            <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>{bookingDetails.gstNumber}</td>
                            <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>{bookingDetails.email || "NA"}</td>
                            <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>{bookingDetails.address || "NA"}</td>
                        </tr>
                    </tbody>
                  </table>
                </>
              )}

              <table style={{ width: "100%", marginTop: "20px" }}>
                 <tbody>
                    <tr>
                        <td>
                            <p style={{ background: "#110942", color: "#dacd65", padding: "8px 15px", fontWeight: "bold" }}>
                                Fare Details
                            </p>
                        </td>
                    </tr>
                 </tbody>
              </table>
              <table style={{ width: "100%", border: "1px solid #ccc", fontSize: "14px" }}>
                 <tbody>
                    <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>Room Price</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee", textAlign: "right" }}>{bookingDetails.currency} {Math.round(bookingDetails.basePrice).toLocaleString()}</td>
                    </tr>
                    <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>Taxes &amp; Fees</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee", textAlign: "right" }}>{bookingDetails.currency} {Math.round(bookingDetails.totalTax|| 0).toLocaleString()}</td>
                    </tr>
                    {/* {bookingDetails.gstAmount > 0 && (
                      <tr>
                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>GST (Inclusive)</td>
                          <td style={{ padding: "8px", borderBottom: "1px solid #eee", textAlign: "right" }}>{bookingDetails.currency} {Math.round(bookingDetails.gstAmount || 0).toLocaleString()}</td>
                      </tr>
                    )} */}
                    <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>Other Charges</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee", textAlign: "right" }}>{bookingDetails.currency} {Math.round(bookingDetails.otherCharges || 0).toLocaleString()}</td>
                    </tr>
                    <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>Management Fee</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee", textAlign: "right" }}>{bookingDetails.currency} {Math.round(bookingDetails.managementFee || 0).toLocaleString()}</td>
                    </tr>
                    <tr>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>Management GST</td>
                        <td style={{ padding: "8px", borderBottom: "1px solid #eee", textAlign: "right" }}>{bookingDetails.currency} {Math.round(bookingDetails.managementFeeTax || 0).toLocaleString()}</td>
                    </tr>
                    <tr style={{ background: "#f8f9fa" }}>
                        <td style={{ padding: "8px" }}><strong>Total Amount Paid</strong></td>
                        <td style={{ padding: "8px", textAlign: "right" }}><strong style={{ fontSize: "18px", color: "#110942" }}>{bookingDetails.currency} {Math.round(bookingDetails.totalPrice || 0).toLocaleString()}</strong></td>
                    </tr>
                 </tbody>
              </table>

              {renderPolicyInstructions()}

              <table style={{ marginTop: "20px", width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <p style={{ background: "#110942", color: "#dacd65", padding: "8px 15px", fontWeight: "bold" }}>
                        Important Information
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <ul style={{ fontSize: "13px", marginTop: "10px", lineHeight: "1.6" }}>
                <li>Please present a government-issued photo identification (Aadhar, Passport, Voter ID, Driving License) at the time of check-in.</li>
                <li>The primary guest must be at least 18 years of age to check into the hotel.</li>
                <li>Standard check-in time is usually 12:00 PM and check-out time is 11:00 AM. However, it may vary by hotel.</li>
                <li>Your booking is confirmed for the number of guests specified. Additional guests may be charged extra by the hotel.</li>
                <li>For any amendment or cancellation, please refer to the cancellation policy.</li>
                <li>Berry Journeys is not responsible for any additional charges levied by the hotel for extra services.</li>
              </ul>

            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default HotelPrintTicket;
